<!-- ----------------------------------------------- -->
<template>
  <nav id="rpHeader" class="primary">
    <v-row class="mb-app-bar-frame mx-0">
      <img
        class="title-pic"
        :src="getTitleImg"
        style="cursor: pointer;"
        v-if="!getModeTest"
      />
      <v-row v-if="!notShowBtn" class="rp-box pa-0 ma-0">
        <v-btn
          text
          small
          color="success"
          class="rp-btn mt-2 mr-2"
          @click="openManual"
        >
        <v-spacer></v-spacer>
          <v-icon left color="white">headset_mic</v-icon>
          <span class="pc-header-link white--text">操作説明</span>
        </v-btn>
        <app-guide-dlg v-if="showGuide" @close="closeManual"></app-guide-dlg>
      </v-row>
    </v-row>
  </nav>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用ヘッダ
 * Header.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
import appGuideDlg from "../../components/mb/AppGuideDlg";

export default {
  /** タグ名 */
  name: "kwb-pc-header",
  mixins: [mixin],
  components: {
    appGuideDlg,
  },
  data() {
    return {
      drawer: null,
      showGuide: false,
    };
  },
  mounted() {
    // 画面サイズ変更イベント
    window.addEventListener("resize", this.handleResize);
    // 画面回転イベント
    window.addEventListener("orientationchange", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize);
  },
  computed: {
    /** URL */
    urls: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls;
      },
    },
    /** タイトル画像のPath */
    getTitleImg: {
      get() {
        let titlePath = "/kawabou/img/apptitle_gen.png";
        if (global.KWB_MODE === "admin") {
          titlePath = "/kawabou/img/apptitle_adm.png";
        }
        return titlePath;
      },
    },
    /** テストモード起動 */
    getModeTest: {
      get() {
        return global.TEST_MODE === "test";
      },
    },
    showSrchDlg: {
      get() {
        return this.$store.state.search.showSrchDlg;
      },
    },
    notShowBtn: {
      get() {
        return this.$store.state.sns.showTwitterCheck;
      },
    },
  },
  methods: {
    /** タイトル画像選択 */
    openPortal() {
      window.location = this.urls.portalpc;
    },
    /** 情報の見方 */
    openHpGuide() {
      window.open(this.urls.hpguide, "_blank");
    },
    /** お知らせ詳細画面表示 */
    openInfoList() {
      // todo: 緊急お知らせ一覧の検索結果を出力するパラメータを設定する
      let routeData = this.$router.resolve({
        name: "info",
        query: {
          fld: this.$store.state.app.fldCtlParty,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /** Q&A */
    openQa() {
      window.open(this.urls.qa, "_blank");
    },
    /** リンク集 */
    openLinkList() {
      window.open(this.urls.linklist, "_blank");
    },
    /** サイトマップ */
    openSiteMap() {
      window.open(this.urls.sitemap, "_blank");
    },
    /** 観測所検索ダイアログ表示 */
    openSrchDlg() {
      this.$store.commit(
        "search/setShowSrchDlg",
        !this.$store.state.search.showSrchDlg
      );
    },
    /** 操作説明 */
    openManual() {
      this.$log.debug("[app]openManual()");
      this.showGuide = true;
    },
    closeManual() {
      this.$log.debug("[app]closeManual()");
      this.showGuide = false;
    },
    /** 画面サイズ変更時処理 */
    handleResize() {
      this.$log.debug("[Map.vue] handleResize()");
      // モバイルのアドレスバー、フッダーメニュー領域の増減に対応
      // vueが生成するclass,window.innerHeightのmin-heightを書き換え
      // リサイズ完了前に高さを取得してしまうことを考慮し、タイマーで動作
      setTimeout(function() {
        let vApplicationWrap = document.getElementsByClassName(
          "v-application--wrap"
        );
        vApplicationWrap[0].style.minHeight = window.innerHeight + "px";
      }, 300);
      // 中心位置がずれるため、地図を再描画
      // 高さ設定前に再描画しないよう、さらにタイマーで動作
      setTimeout(this.$store.commit, 400, "map/mapRedraw");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#rpHeader {
  display: block;
  height: 42px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  z-index: 3500;
}
.mb-app-bar-frame {
  display: flex;
  align-items: center;
  height: 100%;
  color: #fff;

  img {
    height: 100%;
    max-height: 36px;
  }
  .rp-box {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    .rp-btn {
      width: 200px;
    }
  }
}
</style>
